import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ComputersService } from '@shared/services';
import { I18NextModule } from 'angular-i18next';
import { CardModule, MbsUiKitModule } from 'mbs-ui-kit';
import { RmmNotificationService } from 'mbs-ui-shared@services/rmm-notifications.service';
import { NotificationsCheckboxesModule } from '../notifications-checkboxes/notification-checkboxes.module';
import { RMMPushNotificationsModule } from '../push-notifications/push-notifications.component.module';
import { AlertNotificationService } from '../rmm-custom-notification-wizard/services/alert-notification.service';
import { RmmSelectServiceModalModule } from '../rmm-select-service-modal/rmm-select-service-modal.module';
import { SnmpCustomNotificationModule } from '../snmp-custom-notifications/snmp-custom-notifications.module';
import { RmmCustomAlertFull } from './components/rmm-custom-alert-full/rmm-custom-alert-full.component';
import { RmmCustomAlertSimple } from './components/rmm-custom-alert-simple/rmm-custom-alert-simple.component';
import { RmmCustomAlertingServiceController } from './services/rmm-custom-alerting-controller.service';

@NgModule({
  imports: [
    CommonModule,
    MbsUiKitModule,
    NgbTooltipModule,
    FormsModule,
    I18NextModule,
    ReactiveFormsModule,
    CardModule,
    RMMPushNotificationsModule,
    RmmSelectServiceModalModule,
    NotificationsCheckboxesModule,
    SnmpCustomNotificationModule
  ],
  declarations: [RmmCustomAlertSimple, RmmCustomAlertFull],
  providers: [ComputersService, AlertNotificationService, RmmCustomAlertingServiceController, RmmNotificationService],
  exports: [RmmCustomAlertSimple, RmmCustomAlertFull]
})
export class RmmCustomBaseAlertingModule {}
